import { useMemo } from 'react';

import type { ITrendMonths } from '../../helpers/ChartModelHelper';
import { PeriodHelper } from '../../helpers/PeriodHelper';
import type { IComponentFacts } from '../../types/report';

interface IUseTrendMonthsOptions {
  /** Whether this chart may extend past the books-closed month when the filter asks for it. */
  allowPreliminary?: boolean;
}

/**
 * Trend window (at least 12 months ending at the anchor) restricted to months
 * with closed data. Charts that opt in, when the filter has open months on,
 * get the months after the boundary appended and flagged as preliminary.
 */
export const useTrendMonths = (
  facts: IComponentFacts,
  { allowPreliminary = false }: IUseTrendMonthsOptions = {}
): ITrendMonths => {
  const includePreliminary =
    allowPreliminary && (facts.filter.includeOpenMonths ?? false);
  return useMemo(() => {
    const closed = PeriodHelper.trendMonths(facts.resolved).filter((m) =>
      facts.table.byMonth.has(m)
    );
    const endsAtBoundary =
      closed[closed.length - 1] ===
      facts.table.months[facts.table.months.length - 1];
    return includePreliminary && endsAtBoundary
      ? {
          months: [...closed, ...facts.table.preliminaryMonths],
          includePreliminary,
        }
      : { months: closed };
  }, [facts.resolved, facts.table, includePreliminary]);
};
